import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { SCHRIFTZUG } from "@/lib/media";
import ProductCard from "@/components/ProductCard";
import Reveal, { Kicker } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function Merch() {
  const { t } = useLang();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products", { params: { kind: "merch" } })
      .then((r) => setProducts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="merch-page" className="pt-28 md:pt-36 pb-24">
      <Seo path="/merch" title="Merch-Shop | Latschenwirt Krampus-Show" titleEn="Merch Shop | Latschenwirt Krampus Show" description="Offizielle Krampus-Show Merch-Drops: Trucker-Caps und Beanie – limitiert und exklusiv zur Show 2026 in Großgmain." descriptionEn="Official Krampus Show merch drops: trucker caps and beanie – limited and exclusive to the 2026 show in Grossgmain." />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="mb-16 text-center">
          <div className="flex flex-col items-center mb-8">
            <span className="font-cinzel text-[10px] md:text-xs tracking-[0.5em] uppercase text-hell-bone/70 mb-1.5">Die Latschenwirt</span>
            <img src={SCHRIFTZUG} alt="Krampus Show" data-testid="merch-schriftzug" className="h-14 md:h-20 w-auto" />
          </div>
          <Kicker>{t("merch_kicker")}</Kicker>
          <h1 className="font-display text-5xl md:text-7xl headline-gold mt-4 mb-6 ember-glow">{t("merch_hero_t")}</h1>
          <p className="text-hell-smoke max-w-2xl md:mx-auto text-base md:text-lg">{t("merch_hero_d")}</p>
        </Reveal>
        {loading ? (
          <p className="text-hell-smoke font-cinzel tracking-widest">…</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {products.map((p, i) => <ProductCard key={p.product_id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </main>
  );
}
